<template lang="pug">
    div.themeOuter(:class="{'disabled': disabled, 'muted': muted}")
        div.theme(@click="openTheme")
            status-component.themeStatus(v-if="status") {{ status }}
            div.imageWrapper
                img.themeImg(:src="image" alt="title" role="presentation")
                div.imageOverlay

            div.themeName(v-html="title")

            copy-link-component(v-if="isAdmin" :link="url")

</template>

<script>
    import VueTypes from 'vue-types';
    import Status from '~components/Status';
    import { mapGetters } from 'vuex';
    import CopyLink from '../CopyLink';

    export default {
        props: {
            title: VueTypes.string.def(''),
            image: VueTypes.string.def(''),
            imageAlt: VueTypes.string.def(''),
            theme: VueTypes.string.def(''),
            status: VueTypes.string.def(''),
            disabled: VueTypes.bool.def(false),
            muted: VueTypes.bool.def(false),
            duration: VueTypes.number.def(0),
            handleClick: VueTypes.func.def(undefined)
        },
        components: {
            CopyLinkComponent: CopyLink,
            StatusComponent: Status
        },
        computed: {
            ...mapGetters('auth', ['isAdmin']),
            url() {
                return `${process.env.VUE_APP_HOST}/sessions?theme=${
                    this.theme
                }&title=${this.title}${
                    this.duration ? `&duration=${this.duration}` : ''
                }`;
            }
        },
        methods: {
            openTheme() {
                if (this.handleClick)
                    return this.handleClick(this.theme, this.title);
                const query = {
                    title: this.title
                };

                if (this.theme) query.theme = this.theme;

                if (this.duration) query.duration = this.duration;

                return this.$router.push({
                    name: 'dashboard.sessions',
                    query
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl"

    .themeOuter
        overflow: hidden
        border-radius: 10px

        &.disabled
            pointer-events: none
            user-select: none
            opacity: 0.9
            filter: grayscale(50%)

        &.muted
            img
                opacity: 0.85

    .theme
        cursor: pointer
        display: flex
        align-items: center
        justify-content: center
        position: relative
        height: 320px
        /*overflow: hidden*/
        border-radius: 10px
        z-index: 2

    .imageWrapper
        width: 106%
        height: 106%
        position: absolute
        top: -3%
        left: -3%
        z-index: 1

    .themeImg
        position: absolute
        display: block
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
        transform-origin: 50% 50%
        transition: transform 6s
        z-index: 1

    .imageOverlay
        position: absolute
        width: 100%
        height: 100%
        background: linear-gradient(177.08deg, transparent 49.99%, #022341 93.04%)
        z-index: 2

    .themeName
        position: absolute
        bottom: 0
        left: 0
        padding: 7px
        width: 100%
        text-shadow: 0 0 3px rgba(0, 0, 0, 0.2)
        z-index: 3
        font-size: 23px
        font-weight: 500
        line-height: 32px
        text-align: center

    .theme:hover
        .themeImg
            transform: scale(1.15) translate(-50%, -50%)

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .theme
            height: 110px

        .themeName
            font-size: 14px
            line-height: 20px
            padding: 4px 8px
</style>
